const APS = 'APS';
const APX = 'APX';
const SH = 'SH';
const AX = 'AX';
const CC = 'CC';

export default {APS, APX, SH, AX, CC}